/**
 * 功能：请求异常处理
 * 参数：
 *  exception:
 *  {
 *    showInMessage: 显示在Message窗口（默认：true)
 *  }
 */
import { Message } from 'element-ui'

export function handleException (response, config) {
  // 获取参数
  const showInMessage = ((config && config.showInMessage != undefined) ? config.showInMessage : true)
  if (!showInMessage) return
  // 获取错误提示
  const status = response.status
  let statusText = response.statusText
  const text = errorCode.get(status)
  if (text != undefined) { statusText = text }
  statusText = '[ ' + status + ' ] : ' + statusText
  // 提示错误
  Message({
    type: 'error',
    message: statusText
  })
}

// 错误代码
var errorCode = new Map(
  [
    [400, '客户端请求的语法错误'],
    [401, '用户身份无法认证'],
    [403, '服务器拒绝执行请求'],
    [404, '服务器无法根据请求找到资源'],
    [405, '客户端请求中的方法被禁止'],
    [406, '服务器无法根据客户端请求的内容特性完成请求'],
    [407, '用户代理身份无法认证'],
    [500, '服务器内部错误，无法完成请求'],
    [501, '服务器不支持请求的功能，无法完成请求'],
    [502, '网关暂时不可用'],
    [503, '服务暂时不可用'],
    [504, '网关超时'],
    [505, '服务器不支持请求的HTTP协议的版本']
  ])



// WEBPACK FOOTER //
// ./src/utils/request/exception.js